import React from "react";
// Components & styles
import ResourcesSlider from "pages/TherapyHub/components/resourcesSlider";
import Page404 from "pages/404";
import CBDivider from "components/CBDivider";
import PageHeader from "components/CBPageHeader";
import SchemaComponent from "components/CBSchema";
import TextBlock from "components/TextBlock";
import SEO from "components/CBSEO";
import MeetOurTeam from "./components/meetOurTeam";
import PageFooter from "components/CBPageFooter";
// import WhyUs from "pages/WhyChooseUs/components/whyChooseUsForYourMentalHealthJourney";
import { StyledPageContainer } from "styles/components/PageContainer/index.styles";
import FourColumnSection from "styles/components/fourColumnSection";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import { ImageContainer } from "styles/components/imageContainer";
// Utils
import { constructSchemaData } from "utils/helpers/constructSchemaData";
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";
// Data
import aboutUsSchemaData from "./schema.data.json";
import seoData from "./seo.data.json";
import aboutUsContent from "./aboutUsContent.data.json";

const pageContentMap = {
  "about-us": aboutUsContent,
};

const componentMap = {
  "PageHeader": PageHeader,
  "TextBlock": TextBlock,
  "TwoColumnSection": TwoColumnSection,
  "ImageContainer": ImageContainer,
  "Divider": CBDivider,
  "FourColumnSection": FourColumnSection,
  "MeetOurTeam": MeetOurTeam,
  "PageFooter": PageFooter,
  "ResourcesSlider": ResourcesSlider,
};

const SPREAD_PROPS_COMPONENTS = ["PageHeader", "MeetOurTeam", "PageFooter"];

const AboutUs = () => {
  const schemaData = constructSchemaData(aboutUsSchemaData.url, aboutUsSchemaData.breadcrumbs);
  const content = pageContentMap["about-us"];
  const renderedComponents = useDynamicPageRenderer(content, componentMap, SPREAD_PROPS_COMPONENTS);

  if (!content || content.length === 0) {
    return <Page404 />;
  }

  return (
    <StyledPageContainer>
      <SchemaComponent schemas={schemaData} />
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      {renderedComponents}
    </StyledPageContainer>
  );
};

export default AboutUs;
